var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function (resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator['throw'](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = this && this.__generator || function (thisArg, body) {
    var _ = {
            label: 0,
            sent: function () {
                if (t[0] & 1)
                    throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
    return g = {
        next: verb(0),
        'throw': verb(1),
        'return': verb(2)
    }, typeof Symbol === 'function' && (g[Symbol.iterator] = function () {
        return this;
    }), g;
    function verb(n) {
        return function (v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f)
            throw new TypeError('Generator is already executing.');
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y['return'] : op[0] ? y['throw'] || ((t = y['return']) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [
                        op[0] & 2,
                        t.value
                    ];
                switch (op[0]) {
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [0];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2])
                        _.ops.pop();
                    _.trys.pop();
                    continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
import { DetailBusiness } from '@business/details/details';
import {
    Empty,
    Flex,
    Spin,
    Timeline,
    Typography
} from '@one/haven-design';
import { ToolsFill } from '@one/haven-design-icons';
import React, {
    useEffect,
    useState
} from 'react';
import moment from 'moment';
import { inject } from 'mobx-react';
import { observer } from 'mobx-react-lite';
import { PostMessageType } from '@common/enums';
var Title = Typography.Title, Text = Typography.Text, Paragraph = Typography.Paragraph;
export var WoProgressStatus;
(function (WoProgressStatus) {
    WoProgressStatus[WoProgressStatus['IsPassed'] = 1] = 'IsPassed';
    WoProgressStatus[WoProgressStatus['Current'] = 2] = 'Current';
    WoProgressStatus[WoProgressStatus['Pending'] = 3] = 'Pending';
}(WoProgressStatus || (WoProgressStatus = {})));
var itemRender = function (item) {
    return React.createElement(Flex, {
        vertical: true,
        gap: 'small'
    }, React.createElement(Title, {
        level: 5,
        weight: 'Bold',
        style: { color: item.color }
    }, item.title), React.createElement(Text, {
        style: { color: '#5f5f5f' },
        nullIfEmpty: true
    }, item.content), React.createElement(Text, {
        help: true,
        style: { color: '#5f5f5f' },
        nullIfEmpty: true
    }, item.time));
};
var WoStatus = inject(DetailBusiness)(observer(function (_a) {
    var woStatusData = _a.woStatusData, getWoStatusTimeLines = _a.getWoStatusTimeLines, currentWOId = _a.currentWOId;
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    useEffect(function () {
        fetchWoStatusTimeLines();
        var handleMessage = function (event) {
            var data = event.data;
            if (data.type === PostMessageType.UpdateDetail) {
                getWoStatusTimeLines(currentWOId);
            }
        };
        window.addEventListener('message', handleMessage);
        return function () {
            window.removeEventListener('message', handleMessage);
        };
    }, []);
    var fetchWoStatusTimeLines = function () {
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                case 0:
                    _a.trys.push([
                        0,
                        ,
                        2,
                        3
                    ]);
                    setLoading(true);
                    return [
                        4,
                        getWoStatusTimeLines(currentWOId)
                    ];
                case 1:
                    _a.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    setLoading(false);
                    return [7];
                case 3:
                    return [2];
                }
            });
        });
    };
    if (loading) {
        return React.createElement(Flex, {
            justify: 'center',
            align: 'center',
            style: { height: '300px' }
        }, React.createElement(Spin, null));
    }
    if (!woStatusData) {
        return React.createElement(Empty, { tag: 'WOStatusTimeLine_Empty' });
    }
    return React.createElement(Flex, {
        vertical: true,
        gap: 'small',
        style: { color: '#2b2b2b' }
    }, React.createElement(Title, {
        level: 3,
        color: 'colorPrimary5Active'
    }, woStatusData.woNum), React.createElement(Flex, {
        align: 'center',
        gap: 'small'
    }, woStatusData.imageUrl ? React.createElement('img', {
        src: woStatusData.imageUrl,
        width: 44
    }) : React.createElement(ToolsFill, { style: { fontSize: '44px' } }), React.createElement(Title, {
        level: 5,
        weight: 'Bold'
    }, woStatusData.serviceComboName)), React.createElement(Paragraph, { style: { margin: '16px 0' } }, 'As of the latest update on ', moment(woStatusData.lastUpdateTime).format('MMMM DD YYYY'), ', the work order status is ', woStatusData.statusName), React.createElement(Timeline, {
        tag: 'timeLine',
        mode: 'default',
        itemRender: itemRender,
        endMessage: '',
        items: woStatusData.woStatusTimeLines
    }));
}));
export default WoStatus;